/**
 * W3-12 (1): a register ends at the total row its lines add up to. When ProGST
 * stops reading there, the rows it left under the total are counted — and said,
 * because nothing leaves a register in silence.
 */

export function belowTotalNote(count: number | null | undefined): string | null {
  if (!count || count < 1) return null
  const rows = count === 1 ? '1 row' : `${count.toLocaleString('en-IN')} rows`
  return (
    `${rows} under this register's total row ${count === 1 ? 'was' : 'were'} not read. ` +
    'The register ends at the total its lines add up to; what follows it (a summary ' +
    'table) is not sales. Open the file if that is wrong.'
  )
}
